import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import CorporateLayout from "../Layout";
import HubHeader from "../Layout/topHeader";
import { getPage, getParamValue } from "../../../utils/index";
import Loading from "../../common/Loader";
import { ZoomInOutlined, ZoomOutOutlined } from "@ant-design/icons";
import { Button, DatePicker, Empty, Form } from "antd";
import PaginationTwo from "../../common/PaginationTwo";
import { authenticateToken } from "../../../utils/auth";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";
const { RangePicker } = DatePicker;

const CorporateTopupHistoryList = ({ params }: any) => {
  const { corporateInfo } = useSelector((state) => (state as any)?.authReducer);
  const [form] = Form.useForm();
  const [limit, setLimit] = useState(16);
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [activeSearch, setActiveSearch] = useState(false);
  const startOfMonth = moment.utc().startOf("month").format();
  const endOfMonth = moment.utc().endOf("month").format();

  const [range, setRange] = useState({
    from: moment.utc().startOf("month")?.toISOString() || null,
    to: moment.utc().endOf("month")?.toISOString() || null,
  });

  const [topupData, setTopupData] = useState({
    loading: false,
    data: null,
  });

  const getTopupHistory = useCallback(async () => {
    const from = moment(range.from)?.toISOString();
    const to = moment(range.to)?.toISOString();

    setTopupData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_TOPUP_API}`;
    axios
      .get(
        `${encodedUri}/admin/topup/company-history?companyId=${corporateInfo?.ownerId}` +
          (from ? `&from=${from}` : `&from=${startOfMonth}`) +
          (to ? `&to=${to}` : `&to=${endOfMonth}`),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setTopupData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setTopupData({ loading: false, data: [] });
        console.error("Users: Error", err);
      });
  }, [range]);

  useEffect(() => {
    getTopupHistory();
  }, [getTopupHistory]);

  const reseAllFieldData = () => {
    form.resetFields();
    setRange({
      from: null,
      to: null,
    });
  };

  return (
    <React.Fragment>
      <CorporateLayout corporateId={corporateInfo?.id}>
        <div className="product-list-item-area white-bg">
          <HubHeader
            leftarea={"Topup History List"}
            rightarea={
              activeSearch ? (
                <Button
                  type="text"
                  danger
                  onClick={() => {
                    setActiveSearch(false);
                  }}
                  className="mr-2"
                >
                  <ZoomOutOutlined />
                </Button>
              ) : (
                <Button
                  type="text"
                  onClick={() => {
                    setActiveSearch(true);
                  }}
                  className="mr-2"
                >
                  <ZoomInOutlined />
                </Button>
              )
            }
          />

          {activeSearch && (
            <>
              <section className={`search_area`}>
                <Form form={form} className="search_form">
                  <Form.Item name="range">
                    <RangePicker
                      defaultValue={
                        range.from != null && range.to != null
                          ? [moment(range.from), moment(range.to)]
                          : null
                      }
                      onChange={(e, f) => {
                        console.log("momnet", moment.utc(f[0])?.toISOString());
                        setRange({ from: f?.[0], to: f?.[1] });
                      }}
                      showTime={{
                        hideDisabledOptions: true,
                        defaultValue: [
                          moment("00:00:00", "HH:mm:ss"),
                          moment("23:59:59", "HH:mm:ss"),
                        ],
                      }}
                      inputReadOnly
                      allowClear
                    />
                  </Form.Item>
                </Form>
                <div className="search_btn">
                  <Button
                    type="primary"
                    size="large"
                    danger
                    onClick={reseAllFieldData}
                  >
                    Reset
                  </Button>
                </div>
              </section>
            </>
          )}
          <div className="product-list-item-area white-bg section-padding-bottom">
            <div className="">
              <div className="">
                <div className="product-list-items-inner-content">
                  <div className="single-product-wrapper">
                    <div className="single-product-heading">
                      <span>Date & Time</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Number Of Request</span>
                    </div>
                    <div className="single-product-heading text-right">
                      <span>Total Amount</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="">
                {topupData?.loading ? (
                  <Loading />
                ) : (
                  <div className="product-table">
                    <div className="product-table-area">
                      {topupData?.data?.companyTopUps?.length ? (
                        topupData?.data?.companyTopUps?.map((item, index) => (
                          <React.Fragment key={index}>
                            <Link
                              to={`/corporates/${corporateInfo?.id}/topup/${item?.id}`}
                              className="single-product-wrapper"
                            >
                              <div className="single-product">
                                <span className="name">
                                  {moment(item?.createdAt).format("lll")}
                                </span>
                              </div>

                              <div className="single-product">
                                <span className="name">
                                  {item?.numberOfRequest}
                                </span>
                              </div>

                              <div className="single-product justify-content-end">
                                <span className="name text-right">
                                  &#2547; {item?.totalAmount}
                                </span>
                              </div>
                            </Link>
                          </React.Fragment>
                        ))
                      ) : (
                        <Empty />
                      )}
                    </div>
                  </div>
                )}
              </div>

              <PaginationTwo
                {...topupData?.data}
                limit={limit}
                page={getPage(loc.search)}
              />
            </div>
          </div>
        </div>
      </CorporateLayout>
    </React.Fragment>
  );
};

export default CorporateTopupHistoryList;
